"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgUpload04 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M16.379 22.094c-.763.331-1.144.497-1.746.384-.439-.082-1.04-.476-1.29-.846C13 21.125 13 20.568 13 19.454v-9.04l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414L11 10.414v8.93c-.001 1.262-.002 2.257.734 3.298.088.124.192.244.306.358H12C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11c0 4.519-2.725 8.401-6.621 10.094Z", fill: "currentColor" }) }))); };
exports.default = SvgUpload04;
